<template>
  <div class="warn">
    <div class="warn-icon" v-if="showIcon"></div>
    <div class="warn-text">
      <div v-for="item in textArr">{{item}}</div>
    </div>
    <div class="warn-button" @click="confirm">确定</div>
  </div>
</template>

<script>
  import {dtDialog} from "../../util/dialog";

  export default {
    name: "account-dialog",
    props:['textArr','isOpen','showIcon'],
    data(){
      return{
        dialog:null
      }
    },
    mounted(){
      //对话框
      this.dialog=dtDialog({
        el:document.querySelector(".warn")
      })
    },
    methods:{
      confirm(){
        this.$emit("close");
      }
    },
    watch:{
      isOpen(){
        if(this.isOpen){
          this.dialog.open();
        }
        else{
          this.dialog.close();
        }
      }
    }
  }
</script>

<style scoped>
  .warn{
    overflow: hidden;
    width:9.2rem;
    padding-top:0.667rem;
    border-radius: 0.107rem;
    background:#fff;
  }
  .warn-icon{
    height:1.107rem;
    background:url("../../asset/img/account/success.png") center center no-repeat;
    background-size:1.107rem;
  }
  .warn-text{
    margin-top:0.533rem;
    text-align: center;
    color:#666;
    font-size:0.373rem;
    line-height:0.507rem;
  }
  .warn-button{
    margin-top:0.667rem;
    height:1.173rem;
    line-height:1.173rem;
    text-align: center;
    color:#fff;
    font-size:0.427rem;
    background: #0c539b;
  }
</style>



// WEBPACK FOOTER //
// src/components/account-dialog/account-dialog.vue